.wrapper {
  position: relative;
  border-radius: 8px;
  height: 250px;
  width: 100%;
  overflow: hidden;
  z-index: var(--cxy-z-index-background);
}
.wrapper.marginTop {
  margin-top: 16px;
}
@media (max-width: 1023px) {
  .wrapper.marginTop {
    margin-top: 8px;
  }
}
@media (max-width: 767px) {
  .wrapper {
    height: auto;
  }
}
@media (max-width: 767px) {
  .wrapper {
    height: auto;
  }
}
.wrapper .bgImg,
.wrapper .bgColor {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.wrapper .bgImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: var(--cxy-z-index-background);
  transform: scaleX(-1);
}
@media (max-width: 1023px) {
  .wrapper .bgImg {
    object-fit: fill;
  }
}
@media (max-width: 767px) {
  .wrapper .bgImg {
    transform: scaleX(1);
  }
}
.wrapper .bgColor {
  background: var(--ogm-onboarding-bg-color);
  opacity: 0.8;
}
.wrapper .contentWrapper {
  z-index: var(--cxy-z-index-internal-base);
  width: 100%;
  height: 100%;
  min-height: 200px;
  padding: 16px;
  color: var(--ogm-white);
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  cursor: pointer;
  justify-content: flex-end;
  align-items: center;
}
@media (max-width: 1023px) {
  .wrapper .contentWrapper {
    justify-content: space-evenly;
    padding-right: 0;
  }
}
@media (max-width: 767px) {
  .wrapper .contentWrapper {
    flex-flow: column nowrap;
    padding: 16px;
  }
}
.wrapper .contentWrapper .onboardingTitle {
  display: flex;
  flex-direction: column;
  z-index: var(--cxy-z-index-internal-base);
  margin-right: 32px;
}
@media (min-width: 1280px) {
  .wrapper .contentWrapper .onboardingTitle {
    margin-right: 0px;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .wrapper .contentWrapper .onboardingTitle {
    margin-right: 0;
    width: 50%;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .wrapper .contentWrapper .onboardingTitle {
    width: 50%;
  }
}
@media (max-width: 767px) {
  .wrapper .contentWrapper .onboardingTitle {
    margin: 0;
    width: 100%;
  }
}
.onboardingTitle {
  composes: fontH2 from '@cx-web/styles/font.module.css';
}
.wrapper .contentWrapper .onboardingTitle h2 {
  color: var(--ogm-white);
  padding: 4px;
  align-items: center;
  width: 70%;
  text-transform: uppercase;
}
@media (min-width: 650px) and (max-width: 799px) {
  .wrapper .contentWrapper .onboardingTitle h2 {
    width: 100%;
    font-size: 32px;
    line-height: 26px;
  }
}
@media (max-width: 767px) {
  .wrapper .contentWrapper .onboardingTitle h2 {
    width: 100%;
    padding: 4px 0;
  }
}
.wrapper .contentWrapper .onboardingTitle h2.highlight {
  color: var(--ogm-onboarding-accent-color);
  display: block;
  width: 100%;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .wrapper .contentWrapper .onboardingTitle h2.highlight {
    font-size: 32px;
    line-height: 26px;
  }
}
@media (min-width: 650px) and (max-width: 799px) {
  .wrapper .contentWrapper .onboardingTitle h2.highlight {
    width: 80%;
  }
}
.wrapper .contentWrapper .formContainer {
  display: flex;
  flex-flow: column nowrap;
  color: var(--ogm-white);
  margin: 0 64px 16px 32px;
  width: 36%;
  z-index: var(--cxy-z-index-internal-base);
}
@media (min-width: 650px) and (max-width: 799px) {
  .wrapper .contentWrapper .formContainer {
    width: 45%;
  }
}
@media (min-width: 1024px) and (max-width: 1279px) {
  .wrapper .contentWrapper .formContainer {
    width: 40%;
  }
}
@media (max-width: 1023px) {
  .wrapper .contentWrapper .formContainer {
    margin: 0;
  }
}
@media (max-width: 767px) {
  .wrapper .contentWrapper .formContainer {
    justify-content: center;
    margin: 0;
    width: 100%;
  }
}
.description {
  composes: fontBodyL from '@cx-web/styles/font.module.css';
}
.wrapper .contentWrapper .formContainer .description {
  font-family: var(--ogm-font-family-2);
  font-weight: 400;
}
@media (max-width: 767px) {
  .wrapper .contentWrapper .formContainer .description {
    font-size: 16px;
  }
}
.wrapper .contentWrapper .formContainer .inputWrapper {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
}
@media (max-width: 799px) {
  .wrapper .contentWrapper .formContainer .inputWrapper {
    flex-flow: column nowrap;
  }
}
.wrapper .contentWrapper .formContainer .inputWrapper .inputContainer {
  width: 100%;
  margin-top: 0;
}
.input {
  composes: fontBodyM from '@cx-web/styles/font.module.css';
}
.wrapper .contentWrapper .formContainer .inputWrapper .input {
  background-color: transparent;
  width: 100%;
  border: 1px solid var(--ogm-white);
  color: var(--ogm-white);
}
.wrapper .contentWrapper .formContainer .inputWrapper .input::placeholder {
  color: var(--ogm-white);
}
.wrapper .contentWrapper .formContainer .inputWrapper .input:focus {
  border-color: var(--ogm-white);
}
.wrapper .contentWrapper .formContainer .inputWrapper .input.error {
  border: 1px solid var(--ogm-error-color);
}
.wrapper .contentWrapper .formContainer .inputWrapper .input.error:focus {
  border-color: var(--ogm-error-color);
}
.wrapper .contentWrapper .formContainer .inputWrapper .ctaWrapper {
  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
  margin-left: 8px;
  width: 130px;
}
@media (max-width: 799px) {
  .wrapper .contentWrapper .formContainer .inputWrapper .ctaWrapper {
    align-items: unset;
    margin-top: 8px;
    margin-left: 0;
    width: 100%;
  }
}
@media (min-width: 1280px) {
  .wrapper .contentWrapper .formContainer .inputWrapper .ctaWrapper {
    width: 220px;
  }
}
.ctaBtn {
  composes: fontCTA from '@cx-web/styles/font.module.css';
}
.wrapper .contentWrapper .formContainer .inputWrapper .ctaWrapper .ctaBtn {
  font-family: var(--ogm-font-family-2);
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  padding: 8px;
  height: 40px;
  width: 100%;
}
.ctaBtn:disabled {
  filter: grayscale(0.2);
  cursor: not-allowed;
}
@media (min-width: 768px) {
  .wrapper .contentWrapper .formContainer .inputWrapper .ctaWrapper .ctaBtn {
    padding: 16px;
  }
}
.wrapper .contentWrapper .formContainer .errorBanner {
  position: relative;
  background: var(--ogm-onboarding-error-faded-color);
  border-radius: 2px;
  margin-top: 8px;
  padding: 8px;
  box-sizing: border-box;
  width: 100%;
}
.wrapper .contentWrapper .formContainer .errorBanner .errorTitle {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--ogm-error-color);
  width: 100%;
}
.wrapper .contentWrapper .formContainer .errorBanner .errorMessage {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--ogm-onboarding-error-text-color);
  width: 100%;
}
.wrapper.secondary {
  height: auto;
}
.wrapper.secondary .bgImg {
  transform: scaleX(1);
}
.wrapper.secondary .contentWrapper {
  flex-flow: column nowrap;
  padding: 16px;
}
.wrapper.secondary .contentWrapper .onboardingTitle {
  margin: 0;
  margin-bottom: 8px;
  width: 100%;
}
.wrapper.secondary .contentWrapper .onboardingTitle h2 {
  width: 100%;
  padding: 4px 0;
}
.wrapper.secondary .contentWrapper .formContainer {
  margin: 0;
  width: 100%;
}
.wrapper.secondary .contentWrapper .formContainer .inputWrapper {
  display: flex;
  flex-flow: column nowrap;
}
.wrapper.secondary .contentWrapper .formContainer .inputWrapper .ctaWrapper {
  display: flex;
  align-items: unset;
  box-sizing: border-box;
  margin-top: 8px;
  margin-left: 0;
  width: 100%;
}
